/* eslint-disable camelcase */

import _forEach from 'lodash/forEach';
import {
  ACTION_TYPE,
  CONDITION_TYPE,
} from '../../../scenes/Rules/components/InspectRule/constants';

// eslint-disable-next-line import/prefer-default-export
export const getIDsOfRelatedEntities = rule => {
  const set = new Set();

  _forEach(rule.matching_pattern_elements, ({ entity }) => set.add(entity));

  _forEach(rule.actions, ({ action_type, mark_action }) => {
    if (action_type === ACTION_TYPE.MARK) {
      set.add(mark_action.entity);
    }
  });

  _forEach(rule.conditions, ({ condition_type, entity_condition }) => {
    if (condition_type === CONDITION_TYPE.ENTITY) {
      set.add(entity_condition.entity);
    }
  });

  return Array.from(set);
};
